export const IsEmptyObj = (obj) =>
  obj !== undefined && obj !== null && Object.keys(obj).length === 0
    ? true
    : false;

export const RmvEmptyProp = (obj) =>
  !IsEmptyObj(obj) &&
  Object.fromEntries(
    Object.keys(obj)
      .filter((k) => obj[k] !== "" && obj[k] !== null && obj[k] !== undefined)
      .map((k) => [k, obj[k]]),
  );

export const RmvArryEmptyProp = (val) =>
  Object.fromEntries(
    Object.keys(val)
      .filter((k) => val[k])
      .map((key) => [
        key,
        Array.isArray(val[key])
          ? val[key].map((j) => RmvEmptyProp(j))
          : val[key],
      ]),
  );
